import React,{useEffect} from 'react'
import Sorting from '../assets/projects/sorting.png'
import Shopping from '../assets/projects//shopping.png'
import Proctor from '../assets/projects/proctor.png'
import Ide from '../assets/projects/ide.png'
import Upscale from '../assets/projects/upscale.png'
import AOS from 'aos'
import Report from '../assets/projects/Report.pdf'
import 'aos/dist/aos.css'

const Projects = () => {
  useEffect(()=> {
    AOS.init({duration: 1000})
})

  const Projects = () => [
    {
      id: 1,
      src: Sorting,
      desc: "Sorting algorithm visualization tool to illustrate and compare the mechanics and efficiency of various sorting algorithms in real-time.",
      demo: "https://sorting-visualizer-haxor2411s-projects.vercel.app/",
      code: "https://github.com/haxor2411/sorting-visualizer"
    },
    {
      id: 2,
      src: Shopping,
      desc: "This is an E-Commerce Website build for selling of any electronics products online.",
      demo: "https://github.com/haxor2411/shopping-cart",
      code: "https://github.com/haxor2411/shopping-cart"
    },
    {
      id: 3,
      src: Proctor,
      desc: "The Online Exam Proctor System is a computer vision-based project designed to ensure the integrity and fairness of online exams.",
      demo: Report,
      code: "https://github.com/haxor2411/The-Online-Exam-Proctor"
    },
    // {
    //   id: 4,
    //   src: Ide,
    //   // desc: "Keeper is a simple note taking application made using Flutter...",
    //   demo: "https://opeditor.vercel.app/",
    //   code: "https://github.com/dipayansarkar47/online-code-editor"
    // },
    // {
    //   id: 5,
    //   src: Upscale,
    //   // desc: "It is a Weather application which shows temperatures of various cities across the globe made using REST API...",
    //   demo: "https://upscaleai.vercel.app/",
    //   code: "https://github.com/dipayansarkar47/upscale-ai"
    // },
    // {
    //   id: 6,
    //   src: Gist,
    //   // desc: "It is a Face-Detection application made using Python and Computer Vision...",
    //   demo: "https://gist-ai.vercel.app/",
    //   code: "https://github.com/dipayansarkar47/Gist.AI-Summarizer"
    // },
  ]


  return (
    <div name="projects" className='h-auto max-h-screen-lg  bg-gradient-to-b from-black to-gray-800 w-full text-white
     md:h-screen'>
      <div className='max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full'>
        <div className='pb-8'>
          <h2 className='text-4xl font-bold inline border-b-4 border-gray-400'>Projects</h2>
          <p className='py-6'>Check out some of my work </p>
        </div>
        <div   className='grid sm:grid-cols-2 md:grid-cols-3 mb-20 gap-8 px-12 sm:px-0'>
          {
            Projects().map(({ id, src, desc, demo, code }) => (

              <div data-aos="fade-in" data-aos-duration="500" key={id} className='shadow-md shadow-gray-600 rounded-lg'>
                <img src={src} alt="Ai" className='rounded-md duration-200 hover:scale-105' />
                <p className='p-2 text-justify font-extralight'>{desc}</p>
                <div className='flex items-center justify-center'>
                  
                  <button className='w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105 bg-gradient-to-l from-gray-700 to-blue-900 rounded-md'>
                    <a href={demo}>Demo</a>
                  </button>
                  <button  className='w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105 bg-gradient-to-l from-purple-900 to-gray-700 rounded-md'>
                    <a href={code}>Code</a>
                  </button>
                </div>
              </div>

            ))
          }
        </div>
      </div>
    </div>
  )
}

export default Projects